import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../layouts/dashboard/default"));
const AddRole = lazy(() => import("../pages/add-role"));
const AllRoles = lazy(() => import("../pages/all-roles"));

export const RoleManagementRouter = [
  {
    path: "roles",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "listing",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllRoles />
          </Suspense>
        ),
      },
      {
        path: "create",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AddRole />
          </Suspense>
        ),
      },
      {
        path: "edit/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AddRole />
          </Suspense>
        ),
      },
    ],
  },
];
